import * as tslib_1 from "tslib";
import { ActivatedRoute } from '@angular/router';
import { CompanyApi } from '@api/companies.api';
import { LocationGroupApi } from '@api/locationGroup.api';
import { LocationsApi } from '@api/locations.api';
import { MaintenanceTypeApi } from '@api/maintenanceType.api';
import { SegmentApi } from '@api/segments.api';
import { splitStringByComma } from '@core/utils/filters-utils';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { chain, isEmpty, sumBy } from 'lodash';
import moment from 'moment';
import { map } from 'rxjs/operators';
import { ReportsMapperService } from './reports.mapper.service';
import * as i0 from "@angular/core";
import * as i1 from "./reports.mapper.service";
import * as i2 from "@angular/router";
import * as i3 from "../../core/api/maintenanceType.api";
import * as i4 from "../../core/api/locationGroup.api";
import * as i5 from "../../core/api/companies.api";
import * as i6 from "../../core/api/segments.api";
import * as i7 from "../../core/api/locations.api";
import * as i8 from "apollo-angular";
function indexBy(items, property) {
    var e_1, _a;
    var itemsMap = {};
    try {
        for (var items_1 = tslib_1.__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
            var item = items_1_1.value;
            var key = item[property];
            itemsMap[key] = item;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return itemsMap;
}
function statusValueByName(statusMap, status) {
    var item = statusMap[status];
    return (item && item.value) || 0;
}
var ReportsService = /** @class */ (function () {
    function ReportsService(reportsMapperService, route, maintenanceTypeApi, locationGroupApi, companiesApi, segmentsApi, locationApi, apollo) {
        this.reportsMapperService = reportsMapperService;
        this.route = route;
        this.maintenanceTypeApi = maintenanceTypeApi;
        this.locationGroupApi = locationGroupApi;
        this.companiesApi = companiesApi;
        this.segmentsApi = segmentsApi;
        this.locationApi = locationApi;
        this.apollo = apollo;
    }
    ReportsService.prototype.transformFilterIdsToObject = function (filterData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, locations, maintenanceTypes, segments, companies, locationGroups, equaledDateParameters;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            Promise.all(splitStringByComma(filterData.locationId_in).map(function (id) { return _this.locationApi.searchOne(id).toPromise(); })),
                            Promise.all(splitStringByComma(filterData.maintenanceTypeId_in).map(function (id) { return _this.maintenanceTypeApi.searchOne(id); })),
                            Promise.all(splitStringByComma(filterData.segmentId_in).map(function (id) { return _this.segmentsApi.searchOne(id); })),
                            Promise.all(splitStringByComma(filterData.companyId_in).map(function (id) { return _this.companiesApi.searchOne(id); })),
                            Promise.all(splitStringByComma(filterData.locationGroupId_in).map(function (id) { return _this.locationGroupApi.searchOne(id); }))
                        ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 5]), locations = _a[0], maintenanceTypes = _a[1], segments = _a[2], companies = _a[3], locationGroups = _a[4];
                        equaledDateParameters = this.reportsMapperService.equalizeFilterQueryParams(filterData);
                        return [2 /*return*/, {
                                locations: locations.length ? locations : null,
                                initialDate: equaledDateParameters.createdAt_gte ? equaledDateParameters.createdAt_gte : null,
                                finalDate: equaledDateParameters.createdAt_lte ? equaledDateParameters.createdAt_lte : null,
                                maintenanceTypes: maintenanceTypes.length ? maintenanceTypes : null,
                                segments: segments.length ? segments : null,
                                locationGroups: locationGroups.length ? locationGroups : null,
                                companies: companies.length ? companies : null,
                                formContent: filterData.formAnswer_contains || ''
                            }];
                }
            });
        });
    };
    ReportsService.prototype.keepOnlyChangedValuesOnQueryParams = function (currentQueryParams, defaultQueryParams) {
        var e_2, _a, e_3, _b;
        var queryParams = {};
        try {
            for (var _c = tslib_1.__values(Object.keys(currentQueryParams)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var currentKey = _d.value;
                try {
                    for (var _e = (e_3 = void 0, tslib_1.__values(Object.keys(defaultQueryParams))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var defaultKey = _f.value;
                        var isTheSameObjectProperty = currentKey === defaultKey;
                        var objectValueHasChanged = currentQueryParams[currentKey] !== defaultQueryParams[defaultKey];
                        if (currentQueryParams[currentKey] && (isTheSameObjectProperty && objectValueHasChanged)) {
                            queryParams[currentKey] = currentQueryParams[currentKey];
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return queryParams;
    };
    ReportsService.prototype.preserveSavedFilterValues = function (localStorageKey, filterForm, defaultFilterValues) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryParams, hasFilteredDataInTheUrl, filterDataSavedInLocalStorage, filterData, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        queryParams = this.route.snapshot.queryParams;
                        hasFilteredDataInTheUrl = !isEmpty(queryParams);
                        filterDataSavedInLocalStorage = JSON.parse(localStorage.getItem(localStorageKey));
                        if (!!hasFilteredDataInTheUrl) return [3 /*break*/, 1];
                        _a = filterDataSavedInLocalStorage;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.transformFilterIdsToObject(queryParams)];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        filterData = _a;
                        if (filterData) {
                            filterForm.setValue({
                                initialDate: filterData.initialDate ? moment(filterData.initialDate) : defaultFilterValues.initialDate,
                                finalDate: filterData.finalDate ? moment(filterData.finalDate) : defaultFilterValues.finalDate,
                                locations: filterData.locations,
                                maintenanceTypes: filterData.maintenanceTypes ? filterData.maintenanceTypes : null,
                                segments: filterData.segments ? filterData.segments : null,
                                companies: filterData.companies ? filterData.companies : null,
                                locationGroups: filterData.locationGroups ? filterData.locationGroups : null,
                                formContent: filterData.formContent || defaultFilterValues.formContent || ''
                            });
                        }
                        if (filterForm.valid) {
                            return [2 /*return*/];
                        }
                        filterForm.setValue(defaultFilterValues);
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportsService.prototype.accountMaintenancesStatus = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesStatus ($where: DashboardInput!) {\n        accountMaintenancesStatus(where: $where) {\n          reportName\n          items {\n            name: key\n            value\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesStatus ($where: DashboardInput!) {\n        accountMaintenancesStatus(where: $where) {\n          reportName\n          items {\n            name: key\n            value\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        query: query,
                        variables: { where: where },
                        fetchPolicy: 'cache-first'
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        var statusMap = indexBy(data.accountMaintenancesStatus.items, 'name');
                        return {
                            totalMaintenances: sumBy(data.accountMaintenancesStatus.items, 'value'),
                            status: {
                                canceled: statusValueByName(statusMap, 'canceled'),
                                done: statusValueByName(statusMap, 'done'),
                                inProgress: statusValueByName(statusMap, 'inProgress'),
                                new: statusValueByName(statusMap, 'new'),
                                pending: statusValueByName(statusMap, 'pending'),
                                reported: statusValueByName(statusMap, 'reported'),
                                scheduled: statusValueByName(statusMap, 'scheduled'),
                                requested: statusValueByName(statusMap, 'requested'),
                                onNegotiation: statusValueByName(statusMap, 'onNegotiation')
                            },
                        };
                    })];
            });
        });
    };
    ReportsService.prototype.accountMaintenancesStatusInterval = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesStatusInterval ($where: DashboardInput!) {\n        accountMaintenancesStatusInterval (where: $where) {\n          reportName\n          items {\n            key\n            value\n          }\n        }\n      }"], ["\n      query accountMaintenancesStatusInterval ($where: DashboardInput!) {\n        accountMaintenancesStatusInterval (where: $where) {\n          reportName\n          items {\n            key\n            value\n          }\n        }\n      }"])));
                return [2 /*return*/, this.apollo
                        .query({
                        query: query,
                        variables: { where: where },
                        fetchPolicy: 'cache-first'
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data.accountMaintenancesStatusInterval.items.reduce(function (accumulator, _a) {
                            var key = _a.key, value = _a.value;
                            accumulator[key] = value;
                            return accumulator;
                        }, {});
                    })];
            });
        });
    };
    ReportsService.prototype.accountMaintenancesVolumeCount = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesVolumeCount ($where: DashboardInput!) {\n        accountMaintenancesVolumeCount (where: $where) {\n          reportName\n          items {\n            key\n            value\n          }\n        }\n      }"], ["\n      query accountMaintenancesVolumeCount ($where: DashboardInput!) {\n        accountMaintenancesVolumeCount (where: $where) {\n          reportName\n          items {\n            key\n            value\n          }\n        }\n      }"])));
                return [2 /*return*/, this.apollo
                        .query({
                        query: query,
                        variables: { where: where },
                        fetchPolicy: 'cache-first'
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        var totalCount = data.accountMaintenancesVolumeCount.items.find(function (item) { return item.key === 'totalCount'; }).value;
                        var acceptedCount = data.accountMaintenancesVolumeCount.items.find(function (item) { return item.key === 'acceptedCount'; }).value;
                        return chain(data.accountMaintenancesVolumeCount.items)
                            .reduce(function (acc, curr) {
                            var percent = 0;
                            if (totalCount !== 0) {
                                if (curr.key === 'acceptedCount' || curr.key === 'refusedCount') {
                                    percent = parseFloat((curr.value / totalCount * 100).toFixed(1));
                                }
                                else if (curr.key === 'completedCount' || curr.key === 'incompleteCount') {
                                    percent = parseFloat((curr.value / acceptedCount * 100).toFixed(1));
                                }
                            }
                            acc[curr.key] = {
                                value: curr.value,
                                percent: percent
                            };
                            return acc;
                        }, {})
                            .value();
                    })];
            });
        });
    };
    ReportsService.prototype.getAverageDeadlines = function (where) {
        return this.apollo
            .query({
            query: gql(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n          query accountMaintenancesAverageDeadlines($where: DeadlinesWhereInput!) {\n            accountMaintenancesAverageDeadlines(where: $where) {\n              item {\n                maintenanceCount\n                closedOnTimeCount\n                closedOutTimeCount\n                fistVisitOnTimeCount\n                fistVisitOutTimeCount\n                averageCloseTimeInDays\n                closedOnTimePercentage\n                responseOnTimePercentage\n                averageResponseTimeInDays\n                withoutDeadlineCount\n              }\n            }\n          }\n        "], ["\n          query accountMaintenancesAverageDeadlines($where: DeadlinesWhereInput!) {\n            accountMaintenancesAverageDeadlines(where: $where) {\n              item {\n                maintenanceCount\n                closedOnTimeCount\n                closedOutTimeCount\n                fistVisitOnTimeCount\n                fistVisitOutTimeCount\n                averageCloseTimeInDays\n                closedOnTimePercentage\n                responseOnTimePercentage\n                averageResponseTimeInDays\n                withoutDeadlineCount\n              }\n            }\n          }\n        "]))),
            variables: {
                where: {
                    openedAt_lte: where.openedAt_lte,
                    openedAt_gte: where.openedAt_gte,
                    scheduledAt_gte: where.scheduledAt_gte,
                    scheduledAt_lte: where.scheduledAt_lte,
                    closedAt_gte: where.closedAt_gte,
                    closedAt_lte: where.closedAt_lte,
                    maintenanceTypeId_in: where.maintenanceTypeId_in || where.typeId_in,
                    locationId_in: where.locationId_in,
                    segmentId_in: where.segmentId_in,
                    companyId_in: where.companyId_in,
                    locationGroupId_in: where.locationGroupId_in
                }
            },
            fetchPolicy: 'cache-first'
        })
            .pipe(map(function (response) {
            return response.data['accountMaintenancesAverageDeadlines']['item'];
        }));
    };
    ReportsService.prototype.getAccountRatingsCount = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo
                            .query({
                            query: gql(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n          query accountRatingsCountQuery($where: DashboardRatingsWhereInput!) {\n            accountRatingsCount(where: $where) {\n              reportName\n              item {\n                totalCount\n                positiveCount\n                negativeCount\n                averageRating\n                oneStarCount\n                twoStarsCount\n                threeStarsCount\n                fourStarsCount\n                fiveStarsCount\n              }\n            }\n          }\n        "], ["\n          query accountRatingsCountQuery($where: DashboardRatingsWhereInput!) {\n            accountRatingsCount(where: $where) {\n              reportName\n              item {\n                totalCount\n                positiveCount\n                negativeCount\n                averageRating\n                oneStarCount\n                twoStarsCount\n                threeStarsCount\n                fourStarsCount\n                fiveStarsCount\n              }\n            }\n          }\n        "]))),
                            variables: {
                                where: {
                                    openedAt_lte: where.openedAt_lte,
                                    openedAt_gte: where.openedAt_gte,
                                    scheduledAt_gte: where.scheduledAt_gte,
                                    scheduledAt_lte: where.scheduled,
                                    completedAt_gte: where.completedAt_gte || where.closedAt_gte,
                                    completedAt_lte: where.completedAt_lte || where.closedAt_lte,
                                    companyId_in: where.companyId_in,
                                    locationId_in: where.locationId_in,
                                    segmentId_in: where.segmentId_in,
                                    locationGroupId_in: where.locationGroupId_in,
                                    maintenanceTypeId_in: where.maintenanceTypeId_in,
                                }
                            },
                            fetchPolicy: 'cache-first'
                        })
                            .toPromise()
                            .then(function (result) { return result.data.accountRatingsCount.item; })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ReportsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReportsService_Factory() { return new ReportsService(i0.ɵɵinject(i1.ReportsMapperService), i0.ɵɵinject(i2.ActivatedRoute), i0.ɵɵinject(i3.MaintenanceTypeApi), i0.ɵɵinject(i4.LocationGroupApi), i0.ɵɵinject(i5.CompanyApi), i0.ɵɵinject(i6.SegmentApi), i0.ɵɵinject(i7.LocationsApi), i0.ɵɵinject(i8.Apollo)); }, token: ReportsService, providedIn: "root" });
    return ReportsService;
}());
export { ReportsService };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
